import { ApiResponse, fetcher, postFetcher } from './base-api';
import {
  GetStoreListParams,
  KeywordEntity,
  StoreContactEntity,
  StoreEntity,
  StoreListResponse,
  StoreReserveRequest,
  StoreReserveResponse,
} from './types/store.type';

export const getStoreContactList = async (
  type: string,
): Promise<ApiResponse<StoreContactEntity[]>> => {
  return fetcher<StoreContactEntity[]>(`/store/contacts?type=${type}`);
};

export const getStoreDetail = async (
  id: number,
): Promise<ApiResponse<StoreEntity>> => {
  return fetcher<StoreEntity>(`/store/${id}`);
};

export const getHotStoreList = async (): Promise<
  ApiResponse<StoreEntity[]>
> => {
  return fetcher<StoreEntity[]>('/store/hot');
};

export const getStoreList = async (
  params?: GetStoreListParams,
): Promise<ApiResponse<StoreListResponse>> => {
  return fetcher<StoreListResponse>('/store', { params });
};

export const getKeywordList = async (): Promise<
  ApiResponse<KeywordEntity[]>
> => {
  return fetcher<KeywordEntity[]>('/store/keywords');
};

export const postStoreReserve = async (body: StoreReserveRequest) => {
  return postFetcher<StoreReserveResponse, StoreReserveRequest>(
    '/store-reserve',
    body,
  );
};

// 지점(스토어) 리스트 조회 (지점명 등)
export const getStoreNameList = async (): Promise<
  ApiResponse<StoreEntity[]>
> => {
  return fetcher<StoreEntity[]>('/store');
};
